import { buildApiUrl } from '../config/api';

export async function fetchAdmissionConfig(schoolID) {
    const res = await fetch(buildApiUrl(`/api/admissions/public/config/${encodeURIComponent(schoolID)}`));
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Could not load school');
    return data;
}

export async function startApplication(payload) {
    const res = await fetch(buildApiUrl('/api/admissions/public/start'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Could not start application');
    return data;
}

export async function verifyPayment(reference) {
    const res = await fetch(buildApiUrl('/api/admissions/public/paystack-verify'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reference }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Payment verification failed');
    return data;
}

export async function lookupStatus(applicationNumber, phone) {
    const q = new URLSearchParams({ applicationNumber, phone });
    const res = await fetch(buildApiUrl(`/api/admissions/public/status?${q}`));
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Status lookup failed');
    return data;
}

/** Hash-router public apply URL on this app (works with npm start, no separate port). */
export function buildPublicApplyUrl(schoolID) {
    const id = String(schoolID || '').trim();
    if (!id) return '';
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const path = typeof window !== 'undefined' ? window.location.pathname || '/' : '/';
    const base = process.env.REACT_APP_PUBLIC_SITE_URL || `${origin}${path}`;
    const root = base.replace(/\/$/, '').replace(/#.*$/, '');
    return `${root}#/apply/${encodeURIComponent(id)}`;
}

export function buildPublicApplyReturnUrl(schoolID) {
    const id = String(schoolID || '').trim();
    const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';
    const path = typeof window !== 'undefined' ? window.location.pathname || '/' : '/';
    return `${origin}${path}#/apply/${encodeURIComponent(id)}`;
}
